// extracted by mini-css-extract-plugin
export default {"container":"status_container__kWaEl","status_box":"status_status_box__MPZVu"};